export const idps = [
    "https://inrupt.net",
    "https://solidcommunity.net",
]

export const idpMatchers = [
    "inrupt.net",
    "solidcommunity.net",
]